import YTPlayer from 'yt-player';

export default {
    init() {
        if (!document.body.classList.contains('node--type-custom-page')) {
            return;
        }

        document.querySelectorAll('.block-inline-blockvideo-carousel').forEach((element) => {
            this.finalize(element);
        });
    },
    finalize(element) {
        const videoItems  = element.querySelectorAll('.video-item');
        const modal       = element.querySelector('.video-modal');
        const videoHolder = modal.querySelector('.video-player');
        let modalTitle    = modal.querySelector('.title');

        let ytPlayer;

        videoItems.forEach((videoItem) => {
            videoItem.addEventListener('click', (event) => {
                event.preventDefault();

                ytPlayer = new YTPlayer(videoHolder, {
                    autoplay:       true,
                    controls:       false,
                    keyboard:       false,
                    annotations:    false,
                    modestBranding: true,
                    related:        false,
                });

                ytPlayer.load(videoItem.dataset.videoId);
                ytPlayer.play();

                modalTitle.innerHTML = videoItem.dataset.title;

                modal.classList.add('show');
            });
        });

        const close = modal.querySelector('.modal-close');
        close.addEventListener('click', (event) => {
            event.preventDefault();

            modalTitle.innerHTML = '';

            ytPlayer.stop();
            ytPlayer.destroy();

            modal.classList.remove('show');
        });
    },
};
